var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uiw:plus-circle",
    clipPath: "url(#clip0_13064_112267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 5.475C9.8193 5.475 9.64598 5.54672 9.51811 5.6744C9.39024 5.80208 9.31826 5.9753 9.318 6.156V9.28H6.195C6.03156 9.28015 5.8736 9.33899 5.7499 9.44581C5.62619 9.55263 5.54496 9.70032 5.521 9.862L5.513 9.962C5.513 10.339 5.818 10.644 6.195 10.644H9.318V13.767C9.318 14.11 9.57 14.393 9.899 14.442L10 14.449C10.1809 14.449 10.3543 14.3771 10.4822 14.2492C10.6101 14.1213 10.682 13.9479 10.682 13.767L10.681 10.644H13.805C13.9681 10.6439 14.1259 10.5854 14.2495 10.4789C14.3732 10.3725 14.4546 10.2253 14.479 10.064L14.487 9.962C14.4867 9.7813 14.4148 9.60808 14.2869 9.4804C14.159 9.35272 13.9857 9.281 13.805 9.281L10.681 9.28V6.156C10.6809 5.99285 10.6224 5.83514 10.5159 5.71148C10.4095 5.58782 10.2623 5.5064 10.101 5.482L10 5.475Z",
    fill: "#009EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13064_112267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconCircleBlue);
export default __webpack_public_path__ + "static/media/plus-icon-circle-blue.28b08d30a344629f4a83183b09b7fd2e.svg";
export { ForwardRef as ReactComponent };